import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilterConfigState {
  favorites: boolean, 
  type: string[], 
  status: string[],
  setFavorites: (option: boolean) => void;
  setType: (type: string) => void;
  setStatus: (status: string) => void;
  resetFilters: () => void;
  resetOnChange: () => void;
}

export const useFilterConfigStore = create<FilterConfigState>()(
  persist(
    (set, get) => ({
      favorites: JSON.parse(localStorage.getItem('filterFavorites') || 'false'),
      type: JSON.parse(localStorage.getItem('filterType') || '[]'),
      status: JSON.parse(localStorage.getItem('filterStatus') || '[]'),
      setFavorites: (option: boolean) => {
        localStorage.setItem('filterFavorites', JSON.stringify(option));
        set({ favorites: option });
      },
      setType: (type: string) => {
        const types = get().type;
        const exist = types.includes(type);  

        let newTypes = [...types];

        if(exist) {
          newTypes = newTypes.filter((it) => it !== type);
        } else {
          newTypes.push(type);
        }

        localStorage.setItem('filterType', JSON.stringify(newTypes));
        set({ type: newTypes });
      },
      setStatus: (status: string) => {
        const statuses = get().status;
        const exist = statuses.includes(status);  
        let newStatus = [...statuses];

        if(exist) {
          newStatus = newStatus.filter((it) => it !== status);
        } else {
          newStatus.push(status);
        }

        localStorage.setItem('filterStatus', JSON.stringify(newStatus));
        set({ status: newStatus });
      },
      resetFilters: () => {
        localStorage.removeItem('filterFavorites');
        localStorage.removeItem('filterType');
        localStorage.removeItem('filterStatus');

        set({
          status: [],
          type: [],
          favorites: false
        })
      },
      resetOnChange: () => set({
        status: [],
      })
    }),
    {
      name: 'disciplines-filter-config',
    }
  )
);